import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme, useResponsive } from '@sg/garnish';

import { useFloatingBottomBarSpacing } from '@order/shared-hooks';

/**
 * Floating buttons container for the bag screen.
 */
export const BagFloatingCtas = (props: PropsWithChildren) => {
  const { children } = props;

  const { minWidth } = useResponsive();
  const { floatingBottomBarStyle } = useFloatingBottomBarSpacing();

  return (
    <View
      style={[styles.floatingCta, floatingBottomBarStyle, minWidth.isSM && styles.floatingCtaSM]}
    >
      {children}
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  floatingCta: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 1,
    marginHorizontal: theme.spacing['4'],
    gap: theme.spacing['4'],
    flexDirection: 'row',
  },
  floatingCtaSM: {
    paddingBottom: theme.spacing['2'],
  },
});
